var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"color":"cyan lighten-2","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"cyan lighten-2","small":""},domProps:{"textContent":_vm._s('mdi-flask-empty-outline')}},'v-icon',attrs,false),on))]}}])},[_c('span',[_vm._v("ダミー")])])}
var staticRenderFns = []

export { render, staticRenderFns }